import React from 'react';
import { mapConfigs, getMapConfig, MapVariableConfig } from '../../config/mapConfigs';

interface MapVariableSelectorProps {
  selectedVariable: string;
  onVariableChange: (variableId: string) => void;
  disabled?: boolean;
  allowedVariables?: string[];
}

const MapVariableSelector: React.FC<MapVariableSelectorProps> = ({
  selectedVariable,
  onVariableChange,
  disabled = false,
  allowedVariables
}) => {
  let availableConfigs: MapVariableConfig[];

  if (allowedVariables && allowedVariables.length > 0) {
    // Build list from allowed IDs using getMapConfig so we can include configs
    // that are not part of the main mapConfigs array (e.g., political_lean).
    availableConfigs = allowedVariables
      .map((id) => getMapConfig(id))
      .filter((config): config is MapVariableConfig => !!config);
  } else {
    availableConfigs = mapConfigs;
  }

  // If the current selected variable isn't in the allowed list, fall back to the first available option
  const effectiveSelected =
    availableConfigs.some((config) => config.id === selectedVariable)
      ? selectedVariable
      : (availableConfigs[0]?.id ?? selectedVariable);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <label style={{ 
        fontSize: '14px', 
        fontWeight: '500', 
        color: '#333',
        whiteSpace: 'nowrap'
      }}>
        Map Variable:
      </label>
      <select
        id="map-variable-select"
        value={effectiveSelected}
        onChange={(e) => onVariableChange(e.target.value)}
        disabled={disabled}
        style={{
          padding: '6px 12px',
          border: '1px solid #ccc',
          borderRadius: '4px',
          fontSize: '14px',
          backgroundColor: disabled ? '#f5f5f5' : 'white',
          color: disabled ? '#999' : '#333',
          cursor: disabled ? 'not-allowed' : 'pointer',
          minWidth: '180px'
        }}
      >
        {availableConfigs.map((config) => (
          <option key={config.id} value={config.id}>
            {config.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default MapVariableSelector;
